import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-functionalities',
  templateUrl: './functionalities.component.html',
  styleUrls: ['./functionalities.component.css']
})
export class FunctionalitiesComponent implements OnInit {

  mobile:boolean=false;
  medium:boolean=false;
  constructor() { }

  ngOnInit(): void {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    if (window.screen.width <= 768) { // 768px portrait
      this.mobile = true;
    }else {
      this.mobile = false;
    }
    if ($(".main-menu__nav").length && $(".mobile-nav__container").length) {
      let navContent = document.querySelector(".main-menu__nav")!.innerHTML;
      let mobileNavContainer = document.querySelector(
        ".mobile-nav__container"
      );
      mobileNavContainer!.innerHTML = navContent;
    }
    $(".mobile-nav__toggler").on("click", function (e) {
      e.preventDefault();
      $(".mobile-nav__wrapper").toggleClass("expanded");
      $("body").toggleClass("locked");
    });
  }

}
